var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepNavigationmarket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1637_2335)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1637_2335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5611 3.12759H31.7301C31.0841 1.30723 29.3447 0 27.306 0C25.2672 0 23.5278 1.30723 22.8818 3.12759H21.0508C18.4638 3.12759 16.3594 5.23205 16.3594 7.81898C16.3594 8.68335 17.0588 9.38278 17.9232 9.38278H36.6887C37.5531 9.38278 38.2525 8.68335 38.2525 7.81898C38.2525 5.23205 36.1481 3.12759 33.5611 3.12759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5611 3.12759H31.7301C31.0841 1.30723 29.3447 0 27.306 0C25.2672 0 23.5278 1.30723 22.8818 3.12759H21.0508C18.4638 3.12759 16.3594 5.23205 16.3594 7.81898C16.3594 8.68335 17.0588 9.38278 17.9232 9.38278H36.6887C37.5531 9.38278 38.2525 8.68335 38.2525 7.81898C38.2525 5.23205 36.1481 3.12759 33.5611 3.12759Z",
    fill: "url(#paint0_linear_1637_2335)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1637_2335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9439 6.25391H41.2218C41.3249 6.75943 41.3801 7.28226 41.3801 7.8177C41.3801 10.4046 39.2756 12.5091 36.6887 12.5091H17.9231C15.3362 12.5091 13.2317 10.4046 13.2317 7.8177C13.2317 7.28226 13.2869 6.75943 13.39 6.25391H11.668C9.08102 6.25391 6.97656 8.35836 6.97656 10.9453V48.6849C6.97656 51.2719 9.08102 53.3763 11.668 53.3763H42.9439C45.5308 53.3763 47.6353 51.2719 47.6353 48.6849V10.9453C47.6353 8.35836 45.5308 6.25391 42.9439 6.25391ZM22.6145 43.785H16.3593C15.495 43.785 14.7955 43.0856 14.7955 42.2212C14.7955 41.3569 15.495 40.6574 16.3593 40.6574H22.6145C23.4789 40.6574 24.1783 41.3569 24.1783 42.2212C24.1783 43.0856 23.4789 43.785 22.6145 43.785ZM22.6145 32.8385H16.3593C15.495 32.8385 14.7955 32.139 14.7955 31.2747C14.7955 30.4103 15.495 29.7109 16.3593 29.7109H22.6145C23.4789 29.7109 24.1783 30.4103 24.1783 31.2747C24.1783 32.139 23.4789 32.8385 22.6145 32.8385ZM22.6145 21.8919H16.3593C15.495 21.8919 14.7955 21.1924 14.7955 20.3281C14.7955 19.4637 15.495 18.7643 16.3593 18.7643H22.6145C23.4789 18.7643 24.1783 19.4637 24.1783 20.3281C24.1783 21.1924 23.4789 21.8919 22.6145 21.8919ZM37.7943 44.2432C38.4051 44.854 38.4051 45.8437 37.7943 46.4545C37.4888 46.76 37.0887 46.9127 36.6887 46.9127C36.2887 46.9127 35.8885 46.76 35.5831 46.4545L33.5611 44.4325L31.5391 46.4545C31.2337 46.76 30.8335 46.9127 30.4335 46.9127C30.0335 46.9127 29.6333 46.76 29.3279 46.4545C28.7171 45.8437 28.7171 44.854 29.3279 44.2432L31.3498 42.2212L29.3278 40.1992C28.717 39.5884 28.717 38.5988 29.3278 37.9879C29.9386 37.3771 30.9283 37.3771 31.5391 37.9879L33.5611 40.0099L35.5831 37.9879C36.1939 37.3771 37.1836 37.3771 37.7944 37.9879C38.4052 38.5988 38.4052 39.5884 37.7944 40.1992L35.7724 42.2212L37.7943 44.2432ZM39.3581 29.2527L34.6667 33.9441C34.3613 34.2495 33.9611 34.4023 33.5611 34.4023C33.1611 34.4023 32.7609 34.2495 32.4555 33.9441L29.3279 30.8165C28.7171 30.2056 28.7171 29.216 29.3279 28.6052C29.9387 27.9943 30.9284 27.9943 31.5392 28.6052L33.5611 30.6271L37.1469 27.0414C37.7577 26.4305 38.7474 26.4305 39.3582 27.0414C39.969 27.6522 39.969 28.6418 39.3581 29.2527ZM39.3581 19.8699L34.6667 24.5613C34.3613 24.8667 33.9611 25.0195 33.5611 25.0195C33.1611 25.0195 32.7609 24.8667 32.4555 24.5613L29.3279 21.4337C28.7171 20.8229 28.7171 19.8332 29.3279 19.2224C29.9387 18.6116 30.9284 18.6116 31.5392 19.2224L33.5611 21.2444L37.1469 17.6586C37.7577 17.0478 38.7474 17.0478 39.3582 17.6586C39.969 18.2694 39.969 19.2591 39.3581 19.8699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9439 6.25391H41.2218C41.3249 6.75943 41.3801 7.28226 41.3801 7.8177C41.3801 10.4046 39.2756 12.5091 36.6887 12.5091H17.9231C15.3362 12.5091 13.2317 10.4046 13.2317 7.8177C13.2317 7.28226 13.2869 6.75943 13.39 6.25391H11.668C9.08102 6.25391 6.97656 8.35836 6.97656 10.9453V48.6849C6.97656 51.2719 9.08102 53.3763 11.668 53.3763H42.9439C45.5308 53.3763 47.6353 51.2719 47.6353 48.6849V10.9453C47.6353 8.35836 45.5308 6.25391 42.9439 6.25391ZM22.6145 43.785H16.3593C15.495 43.785 14.7955 43.0856 14.7955 42.2212C14.7955 41.3569 15.495 40.6574 16.3593 40.6574H22.6145C23.4789 40.6574 24.1783 41.3569 24.1783 42.2212C24.1783 43.0856 23.4789 43.785 22.6145 43.785ZM22.6145 32.8385H16.3593C15.495 32.8385 14.7955 32.139 14.7955 31.2747C14.7955 30.4103 15.495 29.7109 16.3593 29.7109H22.6145C23.4789 29.7109 24.1783 30.4103 24.1783 31.2747C24.1783 32.139 23.4789 32.8385 22.6145 32.8385ZM22.6145 21.8919H16.3593C15.495 21.8919 14.7955 21.1924 14.7955 20.3281C14.7955 19.4637 15.495 18.7643 16.3593 18.7643H22.6145C23.4789 18.7643 24.1783 19.4637 24.1783 20.3281C24.1783 21.1924 23.4789 21.8919 22.6145 21.8919ZM37.7943 44.2432C38.4051 44.854 38.4051 45.8437 37.7943 46.4545C37.4888 46.76 37.0887 46.9127 36.6887 46.9127C36.2887 46.9127 35.8885 46.76 35.5831 46.4545L33.5611 44.4325L31.5391 46.4545C31.2337 46.76 30.8335 46.9127 30.4335 46.9127C30.0335 46.9127 29.6333 46.76 29.3279 46.4545C28.7171 45.8437 28.7171 44.854 29.3279 44.2432L31.3498 42.2212L29.3278 40.1992C28.717 39.5884 28.717 38.5988 29.3278 37.9879C29.9386 37.3771 30.9283 37.3771 31.5391 37.9879L33.5611 40.0099L35.5831 37.9879C36.1939 37.3771 37.1836 37.3771 37.7944 37.9879C38.4052 38.5988 38.4052 39.5884 37.7944 40.1992L35.7724 42.2212L37.7943 44.2432ZM39.3581 29.2527L34.6667 33.9441C34.3613 34.2495 33.9611 34.4023 33.5611 34.4023C33.1611 34.4023 32.7609 34.2495 32.4555 33.9441L29.3279 30.8165C28.7171 30.2056 28.7171 29.216 29.3279 28.6052C29.9387 27.9943 30.9284 27.9943 31.5392 28.6052L33.5611 30.6271L37.1469 27.0414C37.7577 26.4305 38.7474 26.4305 39.3582 27.0414C39.969 27.6522 39.969 28.6418 39.3581 29.2527ZM39.3581 19.8699L34.6667 24.5613C34.3613 24.8667 33.9611 25.0195 33.5611 25.0195C33.1611 25.0195 32.7609 24.8667 32.4555 24.5613L29.3279 21.4337C28.7171 20.8229 28.7171 19.8332 29.3279 19.2224C29.9387 18.6116 30.9284 18.6116 31.5392 19.2224L33.5611 21.2444L37.1469 17.6586C37.7577 17.0478 38.7474 17.0478 39.3582 17.6586C39.969 18.2694 39.969 19.2591 39.3581 19.8699Z",
    fill: "url(#paint1_linear_1637_2335)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1637_2335",
    x: 14.6941,
    y: 0,
    width: 25.2252,
    height: 12.7134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.66531
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.832656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.221436 0 0 0 0 0.221436 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1637_2335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1637_2335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1637_2335",
    x: 5.31125,
    y: 6.25391,
    width: 43.9908,
    height: 50.4527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.66531
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.832656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.221436 0 0 0 0 0.221436 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1637_2335"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1637_2335",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1637_2335",
    x1: 27.306,
    y1: 0,
    x2: 27.306,
    y2: 9.38278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1637_2335",
    x1: 27.3059,
    y1: 6.25391,
    x2: 27.3059,
    y2: 53.3763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCF9C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1637_2335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.3776,
    height: 53.3776,
    fill: "white",
    transform: "translate(0.621094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepNavigationmarket);
export default __webpack_public_path__ + "static/media/stepNavigationmarket.9f123103b3b46bcca7e2a42d5d20aa1e.svg";
export { ForwardRef as ReactComponent };